import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

type ThemeMode = 'light' | 'dark';
type ThemeColor =
  | ''
  | 'blue'
  | 'ciano'
  | 'grey'
  | 'green'
  | 'red'
  | 'yellow'
  | 'pink'
  | 'purple';

interface ThemeOption {
  value: ThemeColor;
  label: string;
  color: string;
}

@Component({
  selector: 'app-theme-settings-panel',
  standalone: false,
  templateUrl: './theme-settings-panel.component.html',
  styleUrl: './theme-settings-panel.component.css',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ThemeSettingsPanelComponent {
  private readonly modeStorageKey = 'sai_adm_mode';
  private readonly themeStorageKey = 'sai_adm_theme';

  readonly themes: ThemeOption[] = [
    { value: '', label: 'Padrão', color: '#232F3E' },
    { value: 'blue', label: 'Azul', color: '#2B5D96' },
    { value: 'ciano', label: 'Ciano', color: '#0891B2' },
    { value: 'grey', label: 'Cinza', color: '#737373' },
    { value: 'green', label: 'Verde', color: '#015D0D' },
    { value: 'red', label: 'Vermelho', color: '#960909' },
    { value: 'yellow', label: 'Amarelo', color: '#FACC15' },
    { value: 'pink', label: 'Rosa', color: '#AF0347' },
    { value: 'purple', label: 'Roxo', color: '#7E22CE' }
  ];

  selectedMode: ThemeMode = document.documentElement.getAttribute('data-mode') === 'dark'
    ? 'dark'
    : 'light';

  selectedTheme: ThemeColor = this.getCurrentTheme();

  constructor(
    private readonly dialogRef: MatDialogRef<ThemeSettingsPanelComponent>
  ) { }

  selectMode(mode: ThemeMode): void {
    this.selectedMode = mode;
    document.documentElement.setAttribute('data-mode', mode);
    localStorage.setItem(this.modeStorageKey, mode);
  }

  selectTheme(theme: ThemeColor): void {
    this.selectedTheme = theme;

    if (theme) {
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem(this.themeStorageKey, theme);
      return;
    }

    document.documentElement.removeAttribute('data-theme');
    localStorage.removeItem(this.themeStorageKey);
  }

  restoreDefaults(): void {
    this.selectMode('light');
    this.selectTheme('');
  }

  close(): void {
    this.dialogRef.close();
  }

  private getCurrentTheme(): ThemeColor {
    const theme = document.documentElement.getAttribute('data-theme');
    return this.themes.some((option) => option.value === theme)
      ? theme as ThemeColor
      : '';
  }
}
